import { useClose } from "@headlessui/react";
import { GlobalSearchButton } from "@portal/components/ui/GlobalSearch/GlobalSearchButton";
import { Menu } from "@portal/components/ui/Menu";
import { trackingAttrs } from "@portal/components/utils";
import { FC } from "react";
import { useNavigate } from "react-router-dom";

type AgentHeaderActionButtonsProps = {
	hideActionButtons?: boolean;
};

const AccountCreateMenuPanel = () => {
	const navigate = useNavigate();
	const close = useClose();

	return (
		<div className="flex flex-col w-full shrink-0 border border-bc-default rounded-md bg-surface-base px-[3px] py-[5px]">
			<div
				{...trackingAttrs("account-agent-prequal-full-entry")}
				className="flex items-center rounded-md hover:bg-surface-neutral px-[10px] py-[6px] text-[13px] font-medium text-secondary cursor-pointer"
				onClick={() => {
					close();
					navigate("/accounts/create");
				}}
			>
				Prequalification
			</div>
			<div
				{...trackingAttrs("account-agent-combined-full-entry")}
				className="flex items-center rounded-md hover:bg-surface-neutral px-[10px] py-[6px] text-[13px] font-medium text-secondary cursor-pointer"
				onClick={() => {
					close();
					navigate("/accounts/create?type=bond-request");
				}}
			>
				With Bond Request
			</div>
		</div>
	);
};

export const AgentHeaderActionButtons: FC<AgentHeaderActionButtonsProps> = ({
	hideActionButtons,
}) => {
	return (
		<>
			<GlobalSearchButton />
			{!hideActionButtons && (
				<div className="flex space-x-3">
					<Menu
						testId="submit-account-button"
						trackingId="account-agent-entry-menu"
						button={
							<div className="h-[34px] shrink-0 whitespace-nowrap min-w-fit flex items-center justify-center px-[16px] text-sm cursor-pointer select-none font-semibold border border-button-primary text-button-primary hover:border-button-primary-hover hover:text-button-primary-hover active:border-button-primary-active active:text-button-primary-active rounded-[4px]">
								New Submission
							</div>
						}
						panelClassName="shadow-sm shadow-gray-900/10 mt-[4px] w-[185px]"
						anchor="bottom end"
					>
						<AccountCreateMenuPanel />
					</Menu>
				</div>
			)}
		</>
	);
};
